import SearchBar from "../../../../components/SearchBar";
import FilterButtons from "../../../../components/universal-filter-tabs.jsx";
import styles from "../css/expiredStock.module.css";

export default function ExpiredStockFilters({ activeSegment, onSegmentChange, roleId, searchQuery, onSearchChange }) {
  if (roleId === 6) {
    return null; // Clinic role doesn't show filters
  }

  return (
    <div className={styles.filtersBar}>
      <span className={styles.filterLabel}>Search</span>
      <div className={styles.filterInputs}>
        <div className={styles.searchWrap}>
          <SearchBar value={searchQuery} onChange={onSearchChange} placeholder="Search Product" />
        </div>
      </div>
      <FilterButtons
        buttons={["Dispensary", "Front Shop", "Clinic", "OTC"]}
        activeButton={activeSegment}
        onButtonClick={onSegmentChange}
        className={styles.segmentTabs}
      />
    </div>
  );
}
